import { defer } from 'lodash-es';
import Component from 'navigation/component/Component';
import mqStore from 'store/mqStore';
import SuggestionsList from '../suggestions-list/SuggestionList';
class SEOFooter extends Component {
    isMobile = false;
    initialized() {
        super.initialized();
        this.determineCropped();
    }
    bindEvents(add) {
        this.refs.viewMore?.addEventListener('click', this.handleViewMoreClick);
        this.refs.viewLess?.addEventListener('click', this.handleViewLessClick);
    }
    getModulesMap() {
        return {
            suggestions: ['.seo-footer__suggestions-list-wrapper', SuggestionsList]
        };
    }
    getModuleParams(el, componentConstructor) {
        return {
            gradient: true
        };
    }
    handleViewMoreClick = () => {
        this.refs.text?.classList.add('uncropped');
        this.refs.viewMore?.classList.remove('visible');
        this.refs.viewLess?.classList.add('visible');
    };
    handleViewLessClick = () => {
        this.refs.text?.classList.remove('uncropped');
        this.refs.viewMore?.classList.add('visible');
        this.refs.viewLess?.classList.remove('visible');
    };
    determineCropped() {
        if (!this.refs?.text)
            return;
        const isTabletPortrait = mqStore.tabletPortrait.get();
        const maxHeight = (isTabletPortrait ? 26.4 : 24) * 3;
        if (this.refs.text.clientHeight > maxHeight) {
            this.refs.text.classList.add('cropped');
            this.refs.viewMore.classList.add('visible');
        }
        else {
            if (!this.refs.text.classList.contains('cropped'))
                this.refs.text.classList.remove('cropped');
            if (this.refs.viewMore.classList.contains('visible'))
                this.refs.viewMore.classList.remove('visible');
        }
        this.refs.viewLess.classList.remove('visible');
    }
    resize() {
        super.resize();
        const isMobile = mqStore.tabletPortrait.get();
        if (this.isMobile !== isMobile) {
            this.isMobile = isMobile;
            this.refs.text?.classList.remove('cropped');
            this.refs.text?.classList.remove('uncropped');
            this.refs.viewMore?.classList.remove('visible');
            this.refs.viewLess?.classList.remove('visible');
            defer(() => {
                this.determineCropped();
            });
        }
    }
}
export default SEOFooter;
